import { ApiPath } from 'enums';
import { Get, Post } from 'utils';

export const getUsers = async ({ ...query }) => {
  const res = await Get(`${ApiPath.User}`, query);
  return res.data;
};

export const createUser = async ({ ...body }) => {
  const res = await Post(`${ApiPath.User}/register`, body);
  return res.data;
};

export const updateUser = async ({ userId, ...body }) => {
  const res = await Post(`${ApiPath.User}/update`, { ...body, userId });
  return res.data;
};
